import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { ResourceAllocationStatus } from '~/types';

export const COMPLETED_RESOURCE_ALLOCATIONS_SUMMARY_QUERY = gql`
  query GetCompletedResourceAllocationsSummary(
    $projectId: String!
    $filter: ProjectResourceAllocationCountFilter!
    $allocationStatusList: [ResourceAllocationStatus!]!
    $includeAllocations: Boolean!
    $includeTaskRollup: Boolean!
  ) {
    project(projectId: $projectId) {
      id
      isTaskDateRollupEnabled @include(if: $includeTaskRollup)
      allocationsTotals(allocationStatusList: $allocationStatusList)
        @include(if: $includeAllocations) {
        totalHours
      }
      resourceAllocationCount(filter: $filter) @include(if: $includeAllocations)
    }
  }
`;

const useCompletedResourceAllocationsSummary = ({
  projectId,
  skip,
  includeAllocations,
  includeTaskRollup
}) => {
  const { data, loading } = useQuery(
    COMPLETED_RESOURCE_ALLOCATIONS_SUMMARY_QUERY,
    {
      variables: {
        projectId,
        includeAllocations,
        includeTaskRollup,
        allocationStatusList: [ResourceAllocationStatus.Committed],
        filter: {
          allocationStatusList: [ResourceAllocationStatus.Committed]
        }
      },
      skip,
      fetchPolicy: 'cache-and-network'
    }
  );

  return {
    projectResourceAllocationsSummary: {
      totalAllocatedHours: data?.project?.allocationsTotals?.totalHours?.toFixed(
        2
      ),
      resourceAllocationCount: data?.project?.resourceAllocationCount
    },
    isTaskDateRollupEnabled: data?.project?.isTaskDateRollupEnabled,
    loading
  };
};

export default useCompletedResourceAllocationsSummary;
